async function elementUpdate(selector) {
    try {
        // console.log('Перерисовка')
        // var html = await (await fetch(location.href)).text();
        // var newdoc = new DOMParser().parseFromString(html, 'text/html');
        // document.querySelector(selector).outerHTML = newdoc.querySelector(selector).outerHTML;
        // // console.log('Элемент '+selector+' был успешно обновлен');
        // setTimeout(editEmployee(), 500)
        location.reload()
        return true;
    } catch (err) {
        // console.log('При обновлении элемента '+selector+' произошла ошибка:');
        // console.dir(err);
        return false;
    }
}

function paEmployee() {
    if (document.querySelector('.popup-add-employee')) {
        let parentElem = document.querySelector('.popup-add-employee')
        let form = parentElem.querySelector('form')

        let bd = form.querySelector('[name="birthday"]')

        let inputs = form.querySelectorAll('.Input__inp')

        inputs.forEach(inp => {
            inp.oninput = () => {
                if (inp.value) {
                    inp.classList.add('Input--valid')
                    inp.classList.remove('Input--invalid')
                } else {
                    inp.classList.remove('Input--valid')
                    inp.classList.add('Input--invalid')
                }
            }
        })

        bd.onchange = () => {
            if (bd.value) {
                bd.classList.add('Input--valid')
                bd.classList.remove('Input--invalid')
            } else {
                bd.classList.remove('Input--valid')
                bd.classList.add('Input--invalid')
            }
        }

        parentElem.querySelector('[name="birthday"]').onfocus = () => {
            parentElem.querySelector('[name="birthday"]').setAttribute('type', 'date')
            parentElem.querySelector('[name="birthday"]').oninput = () => {
                let arr = parentElem.querySelector('[name="birthday"]').value
                arr = arr.split('-')
                if (parseInt(arr[0]) > 2030) {
                    arr[0] = new Date().getFullYear()
                    parentElem.querySelector('[name="birthday"]').value = `${arr[0]}-${arr[1]}-${arr[2]}`
                }
            }
        }

        $(".Input--birth-day").keyup(function (e) {
            this.value = this.value.replace(/[^0-9\.]/g, '');
            if (this.value > ($(this).attr('max') / 1) || this.value < ($(this).attr('min') / 1)) {
                this.value = ''
            }
        })

        let roleDrop = form.querySelector('.dropdown--role')
        let roleSelect = roleDrop.querySelectorAll('.dropdown__list-item')
        let showDes = roleDrop.querySelector('.Privacy-policy')
        let parLabel = roleDrop.querySelector('label')

        parLabel.onmousedown = e => {
            parLabel.toggleAttribute('checked')
        }

        roleSelect.forEach(el => {
            el.setAttribute('data-val', el.querySelector('span').textContent)
            el.onclick = () => {
                if (el.getAttribute('data-val') === showDes.getAttribute('data-show')) {
                    showDes.removeAttribute('style')
                } else {
                    showDes.style.display = "none"
                }
            }
        })
    }
}

function employeeOutPut(form) {
    let inputs = form.querySelectorAll('.Input--valid')
    let selectors = form.querySelectorAll('.dropdown__button--valid')

    let roleDrop = form.querySelector('.dropdown--role')
    let roleSelect = roleDrop.querySelectorAll('.dropdown__list-item')
    let showDes = roleDrop.querySelector('.Privacy-policy')
    let parLabel = roleDrop.querySelector('label')

    let successMsg = form.querySelector('[data-status-success]')
    let errorMsg = form.querySelector('[data-status-error]')

    // let name = inputs[0].value + ' ' + inputs[1].value + ' ' + inputs[2].value
    // let dateB = inputs[3].value + '.' + inputs[4].value + '.' + inputs[5].value
    let name = inputs[0].value
    let dateB = inputs[1].value


    let body

    if (selectors[0].querySelector('.dropdown__button-text').textContent === showDes.getAttribute('data-show')) {
        let isChecked

        parLabel.hasAttribute('checked') ? isChecked = 'Y' : isChecked = 'N'

        body = {
            name: name,
            dateBir: dateB,
            // mail: inputs[6].value,
            // phone: inputs[7].value,
            mail: inputs[2].value,
            phone: inputs[3].value,
            role: selectors[0].querySelector('.dropdown__button-text').textContent,
            showOrders: isChecked,
            jobTitle: selectors[1].querySelector('.dropdown__button-text').textContent,
            subordination: selectors[2].querySelector('.dropdown__button-text').textContent
        }
    } else {
        body = {
            name: name,
            dateBir: dateB,
            // mail: inputs[6].value,
            // phone: inputs[7].value,
            mail: inputs[2].value,
            phone: inputs[3].value,
            role: selectors[0].querySelector('.dropdown__button-text').textContent,
            jobTitle: selectors[1].querySelector('.dropdown__button-text').textContent,
            subordination: selectors[2].querySelector('.dropdown__button-text').textContent
        }
    }

    $.ajax({
        // url: 'https://jsonplaceholder.typicode.com/posts',
        url: form.getAttribute('data-action'),
        method: 'post',
        dataType: 'json',
        data: body,
        success: response => {
            if (response.status === 'success') {
                elementUpdate('#employers');
                // elementUpdate('#employersedit');
                errorMsg.style.display = 'none'
                successMsg.removeAttribute('style')
            } else {
                successMsg.style.display = 'none'
                errorMsg.removeAttribute('style')
            }
        },
        error: response => {
            successMsg.style.display = 'none'
            errorMsg.removeAttribute('style')
        }
    })

}